const AD_CAMPAIGN_PATTERN = /^ads_[a-z0-9][a-z0-9_-]{0,59}$/;

export function isAdCampaignStartParameter(
  value: string | null,
): value is string {
  return value !== null && AD_CAMPAIGN_PATTERN.test(value);
}

export async function recordAdCampaignOpen(
  initData: string,
  startParameter: string | null,
): Promise<boolean> {
  if (!initData || !isAdCampaignStartParameter(startParameter)) {
    return false;
  }
  const response = await fetch("/api/ad-attribution/open", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({ initData }),
  });
  if (!response.ok) {
    throw new Error("ad_attribution_failed");
  }
  return true;
}
